const blobToBase64Url = (blob: Blob): Promise<string> =>
  new Promise((resolve) => {
    const reader = new FileReader()

    reader.onloadend = () => resolve(reader.result as string)

    reader.readAsDataURL(blob)
  })

export { blobToBase64Url }
